/**
 * Shared file helper utilities.
 *
 * Centralizes common patterns used across multiple frontend files.
 */

/**
 * Extract the field_id from a file object using a consistent fallback chain.
 *
 * Different API responses and state shapes may store the field ID under
 * different keys. This utility normalizes access so every component uses
 * the same extraction logic.
 *
 * @param {Object} file - A file metadata object
 * @returns {string|null} The field ID or null
 */
export function getFileFieldId(file) {
  return file.fieldId || file.field_id || file.context?.field_id || null;
}
